import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailViewedAfterSignupParams = {
  trail_id: string;
};

/**
 * Trail was viewed by the user after signing up (to be fired after successful web modal signup)
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The id of the trail viewed by the user
 */
const logTrailViewedAfterSignup = ({ trail_id }: logTrailViewedAfterSignupParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail viewed after signup', { 'trail id': trail_id }, callback);
};

export default logTrailViewedAfterSignup;
